// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__16f38","content":"Login_content__gSyIm","title":"Login_title__g6im3","selection":"Login_selection__28G9E"};